import {
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { ResourceType } from '@repo/api-gw-sdk';

import { SupportedResourceTypesText } from '@/app/(dashboard)/settings/backup-policies/supportedResourceTypesText';
import type { FieldConfig } from '@/components/form/validation/fieldValidation';

import { FormTextField } from '../../../../../components/form/formTextField';

interface AzureAgentState {
  agent_app_application_id?: string;
  agent_app_service_principal_id?: string;
  agent_managed_identity_resource_id?: string;
}

interface AzureOnboardAgentSectionProps {
  visible: boolean;
  onboardAgentApp: boolean;
  setOnboardAgentApp: (value: boolean) => void;
  agentAppApplicationId: string;
  agentAppServicePrincipalId: string;
  agentManagedIdentityResourceId: string;
  onAgentStateChange: (update: Partial<AzureAgentState>) => void;
  appIdConfig: FieldConfig;
  servicePrincipalIdConfig: FieldConfig;
  managedIdentityResourceIdConfig: FieldConfig;
}

export const AzureOnboardAgentSection = (
  props: AzureOnboardAgentSectionProps
) => {
  if (!props.visible) {
    return null;
  }

  return (
    <Stack gap='24px'>
      <Divider />
      <FormControlLabel
        control={
          <Switch
            size='small'
            checked={props.onboardAgentApp}
            onChange={(_, checked) => props.setOnboardAgentApp(checked)}
            sx={{
              marginRight: '12px',
            }}
          />
        }
        label='Onboard agent application'
      />
      <Typography variant='body1' sx={{ marginTop: '-12px' }}>
        Available for&nbsp;
        <SupportedResourceTypesText
          resourceTypes={[ResourceType.AzureSapHanaVm]}
        />
      </Typography>
      {props.onboardAgentApp && (
        <Stack gap='12px'>
          <FormTextField
            title='agent_app_application_id'
            validation={props.appIdConfig.validation}
            placeholder={props.appIdConfig.placeholder}
            value={props.agentAppApplicationId}
            onChange={(event) =>
              props.onAgentStateChange({
                agent_app_application_id: event.target.value,
              })
            }
          />
          <FormTextField
            title='agent_app_service_principal_id'
            validation={props.servicePrincipalIdConfig.validation}
            placeholder={props.servicePrincipalIdConfig.placeholder}
            value={props.agentAppServicePrincipalId}
            onChange={(event) =>
              props.onAgentStateChange({
                agent_app_service_principal_id: event.target.value,
              })
            }
          />
          <FormTextField
            title='agent_managed_identity_resource_id'
            validation={props.managedIdentityResourceIdConfig.validation}
            placeholder={props.managedIdentityResourceIdConfig.placeholder}
            value={props.agentManagedIdentityResourceId}
            onChange={(event) =>
              props.onAgentStateChange({
                agent_managed_identity_resource_id: event.target.value,
              })
            }
          />
        </Stack>
      )}
    </Stack>
  );
};
